import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';
import TYPOGRAPHY from 'Components/foundation/typography';

const styleSheet = createStyleSheet({
  wrapper: {
    display: 'flex',
    height: '100vh',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'fixed',
    top: 0,
    height: '100%',
  },
  contentMiddle: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentDimmed: {
    opacity: 0.05,
  },
  contentBottom: {
    display: 'flex',
    flexGrow: 0.5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sparklesAnimation: {
    width: 62,
    height: 64,
  },
  subtitle: {
    ...TYPOGRAPHY.TITAN_L_BOLD,
    background: 'linear-gradient(90deg, #348FFC 0%, #9747FF 100%)',
    color: 'transparent',
    WebkitBackgroundClip: 'text',
    marginBottom: '25px',
  },
  description: {
    ...TYPOGRAPHY.BODY1,
    textAlign: 'center',
    marginBottom: '25px',
  },
  loadingText: {
    ...TYPOGRAPHY.BODY2,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    marginTop: '8px',
  },
  disclamer: {
    ...TYPOGRAPHY.BODY1,
  },
  modalBackground: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 10,
    backgroundColor: '#222A3477',
  },
  modalCard: {
    backgroundColor: COLORS.WHITE.DEFAULT,
    height: 'auto',
    width: 800,
    borderRadius: 12,
    border: `1px solid ${COLORS.GREY_MEDIUM.DEFAULT}`,
    padding: '16px 20px',
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  modalButtonClose: {
    alignSelf: 'flex-end',
  },
  modalTitle: {
    ...TYPOGRAPHY.H1_BOLD,
  },
  modalBody: {
    margin: '32px 4px',
  },
  modalText: {
    ...TYPOGRAPHY.BODY1,
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },
});

export default styleSheet;
